export default __webpack_public_path__ + "static/media/doctors-portal.815a7cc0.png";